import api from './axios';
import {authHeader} from '../helpers';
import {authService} from './authentication.service';

export const mesuresService = {
    getVariableData,
    getVariablesData,
    getVariablesMetaData,
    writeNumericVariable,
    writeTextVariable,
    exportCSV,
    handleAPIResponse
};

async function getVariablesData(variableIds, start, stop) {
    if (!Array.isArray(variableIds)) {
        variableIds = [variableIds];
    }
    if (!start) {
        start = '1901-01-01T00:00:00.000Z';
    }
    if (!stop) {
        stop = new Date().toJSON();
    }

    let dataToReturn = {series: []};

    while (variableIds.length > 0) {
        const chunk = variableIds.splice(0, 10);

        const response = await api.get(`/Mesure/q?ids=${chunk.join(',')}&start=${start}&stop=${stop}&fields=*&dataUnit=Display&extendedPeriod=false&aggregate=none`, {
            headers: authHeader()
        })
            .then(handleAPIResponse);
        if (response.length > 0) {
            response.forEach(ds => {
                if (ds && ds.series && ds.series.length > 0) {
                    dataToReturn.series.push(...ds.series);
                }
            });
        }
    }

    return dataToReturn;
}

async function exportCSV(variableIds, start, stop, datePerVar,form) {
    if (!Array.isArray(variableIds)) {
        variableIds = [variableIds];
    }
    if (!start) {
        start = '1901-01-01T00:00:00.000Z';
    }
    if (!stop) {
        stop = new Date().toJSON();
    }

    let dataToReturn = {series: []};


    return await api.post(`/Mesure/generer?ids=${variableIds.join(',')}&start=${start}&stop=${stop}&datePerVar=${datePerVar}`,form, {
        headers: authHeader(),
        responseType: 'blob' // Required for handling file downloads

    })
        .then(response => {
            // Accéder aux en-têtes via response.headers (cas insensitive)
            const headers = response.headers;
            let contentDisposition = headers['content-disposition'] || headers['Content-Disposition'];
            let fileName = 'downloaded_file.xlsx'; // Nom par défaut

            // Vérifier si l'en-tête est présent et extraire le nom du fichier
            if (contentDisposition) {
                const match = contentDisposition.match(/filename="?(.+?)"?;/i);
                if (match && match[1]) {
                    fileName = match[1];
                }
            }

            const blob = response.data;
            const a = document.createElement('a');
            a.style.display = 'none';
            let url = null;

            if (window.navigator.msSaveOrOpenBlob) {
                a.onclick = () => {
                    window.navigator.msSaveOrOpenBlob(blob, fileName);
                };
            } else {
                url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = fileName;
            }

            document.body.appendChild(a);
            a.click();
            if (url) window.URL.revokeObjectURL(url);
            a.remove();

            return response.data;
        })
        .catch(async error => {
            if (error.response && error.response.data) {
                try {
                    const errorData = error.response.data instanceof Blob
                        ? JSON.parse(await error.response.data.text())
                        : error.response.data;
                    throw new Error(JSON.stringify(errorData));
                } catch (parseError) {
                    throw error;
                }
            }
            throw error;
        });


}

async function getVariableData(variableId, start, stop) {
    if (!start) {
        start = '1901-01-01T00:00:00.000Z';
    }
    if (!stop) {
        stop = new Date().toJSON();
    }

    let dataToReturn = {series: []};

    if (variableId) {
        const response = await api.get(`/Mesure/q?ids=${variableId}&start=${start}&stop=${stop}&fields=*&dataUnit=Display&extendedPeriod=false&aggregate=none`, {
            headers: authHeader()
        })
            .then(handleAPIResponse);

        if (response && response.length > 0) {
            dataToReturn.series = dataToReturn.series.concat(response[0].series);
        }
    }

    return dataToReturn;
}

async function getVariablesMetaData(variablesIds) {
    if (!Array.isArray(variablesIds)) {
        variablesIds = [variablesIds];
    }

    let dataToReturn = [];

    while (variablesIds.length > 0) {
        const chunk = variablesIds.splice(0, 10);

        const response = await api.get(`/Variables/metadata?variableGuids=${chunk.join('&variableGuids=')}`, {
            headers: authHeader()
        })
            .then(handleAPIResponse);

        if (response && response.length > 0) {
            dataToReturn = dataToReturn.concat(response);
        }
    }

    return dataToReturn;
}

function writeNumericVariable(variables, isUTC) {

    if (!variables || variables.length === 0) {
        return;
    }

    const payload = variables.map(v => {
        if (!v.listeMesure || v.listeMesure.length === 0) {
            return null;
        }

        const measures = v.listeMesure.map(m => ({
            timestamp: m.dateMesure,
            value: m.valeurMesure
        }));

        return {id: v.guidVariable, points: measures, typeVariable: v.typeVariable};
    }).filter(item => item !== null);

    return api.post(`/Mesure/writeNumericValues?isUTC=${isUTC}`, payload, {
        headers: authHeader()
    })
        .then(handleAPIResponse);
}

function writeTextVariable(variables, isUTC) {

    if (!variables || variables.length === 0) {
        return;
    }

    const payload = variables.map(v => {
        if (!v.listeMesure || v.listeMesure.length === 0) {
            return null;
        }

        const measures = v.listeMesure.map(m => ({
            timestamp: m.dateMesure,
            value: m.valeurMesure
        }));

        return {id: v.guidVariable, points: measures, typeVariable: v.typeVariable};
    }).filter(item => item !== null);

    return api.post(`/Mesure/writeTextValues?isUTC=${isUTC}`, payload, {
        headers: authHeader()
    })
        .then(handleAPIResponse);
}

function handleAPIResponse(response) {
    const data = response.data;

    if (response.status !== 200) {
        if (response.status === 401) {
            authService.logout();
        }

        return Promise.reject(data);
    }

    return data;
}
